import {
  rbcHtsAssistApi,
  type GenerateTokenRequest,
  type GenerateTokenResponse,
} from "@b2bportal/rbc-hts-assist-api";
import { axiosInstance } from "@hopper-b2b/api";

export type GenerateHtsAssistTokenRequest = GenerateTokenRequest;
export type GenerateHtsAssistTokenResponse = GenerateTokenResponse;

export const generateHtsAssistToken = async (
  request: GenerateHtsAssistTokenRequest = {}
): Promise<GenerateHtsAssistTokenResponse> => {
  const response =
    await rbcHtsAssistApi(axiosInstance).apiV0HtsAssistGenerateTokenPost(
      request
    );
  return response.data;
};
